<div class="container-fluid">
  <div class="row justify-content-start">
    <div class="col-md-8 col-xs-12">
      <div class="mt-3" name="timeSpan" aria-label="Time Span">
        <mat-button-toggle class="lw-toggle-btn" [ngClass]="this.timespan === 'weekly' ? 'active' : ''" value="weekly" (click)="changeTimeSpan('weekly')">Weekly</mat-button-toggle>
        <mat-button-toggle class="lw-toggle-btn" [ngClass]="this.timespan === 'monthly' ? 'active' : ''" value="monthly" (click)="changeTimeSpan('monthly')">Monthly</mat-button-toggle>
        <mat-button-toggle class="lw-toggle-btn" [ngClass]="this.timespan === 'custom' ? 'active' : ''" value="custom" (click)="changeTimeSpan('custom')">Custom</mat-button-toggle>
      </div>
      @if (data) {
        <lds-feature-list [timespan]="timespan" [features]="features" [data]="data"
        [productCode]="featureSet.productCode" [deviceType]="deviceType"></lds-feature-list>
      }
      @if (hasNoData) {
        <p>No Data</p>
      }
      @if (!hasNoData) {
        <div class="left-graph-container">
          @if (data) {
            <lds-y3-graph [productCode]="featureSet.productCode" [data]="data" [isOctopus]="isOctopus" [features]="features" [deviceType]="deviceType"
            [timespan]="timespan" [startTime]="startTime" [endTime]="endTime"></lds-y3-graph>
          }
          <!-- <app-graph [data]= "switchData" [features]= "switchFeatures" graphName = "device-detail" *ngIf="show"></app-graph> -->
          <!-- <app-graph [data]= "recentActivity" graphName = "recentActivity" *ngIf="recentActivity"></app-graph> -->
        </div>
      }
    </div>
  </div>
  @if (data) {
    <div class="below-graph">
      <button class="lds-btn" (click)="onExportClick()">Export Data</button>
    </div>
  }
</div>
